import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { TicketsComponent } from './tickets/tickets.component';
import { ExploreComponent } from './explore/explore.component';
import { PartnersComponent } from './partners/partners.component';
import { ScheduleComponent } from './schedule/schedule.component';
import { PracticalComponent } from './practical/practical.component';
import { AboutComponent } from './about/about.component';
import { CoachingComponent } from './coaching/coaching.component';
import { SpeakersComponent } from './speakers/speakers.component';
import { SpeakerComponent } from './speaker/speaker.component';


const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'tickets', component: TicketsComponent},
  {path: 'explore', component: ExploreComponent},
  {path: 'partners', component: PartnersComponent},
  {path: 'schedule', component: ScheduleComponent},
  {path: 'practical', component: PracticalComponent},
  {path: 'about', component: AboutComponent},
  {path: 'coaching', component: CoachingComponent},
  {path: 'speakers', component: SpeakersComponent},
  {path: 'speaker/:name', component: SpeakerComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
